import { getClipParams } from '../../utils/animationsUtils';
import { toArray } from '@wix/wow-utils';
const name = 'BaseClipPath';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, { to = {}, from = {}, useClipRect = false, ...params } = {}) {
    const sequence = kit.sequence();
    elements = toArray(elements);
    elements.forEach((element) => {
        const compRect = kit.engine.getBoundingRect(element);
        const contentRect = kit.engine.getBoundingContentRect(element);
        const initialClipPath = getClipParams(compRect, contentRect, 'initial', {
            useClipRect,
        });
        sequence.add(kit.engine.tween(element, {
            duration,
            delay,
            to: {
                ...initialClipPath,
                ...to,
            },
            from: {
                ...initialClipPath,
                ...from,
            },
            ...params,
        }, ['clipPath', 'webkitClipPath', 'clip']), 0);
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=baseClipPath.js.map